import { render, staticRenderFns } from "./StatusPackage.vue?vue&type=template&id=677454be&"
import script from "./StatusPackage.vue?vue&type=script&lang=js&"
export * from "./StatusPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports